import { Navigate } from 'react-router-dom'

/**
 * Sign-up disabled — Google OAuth is the only auth path, and provisioning
 * is managed manually (authorised emails only). Anyone hitting /sign-up
 * gets bounced to /sign-in which shows the Google button.
 */
export function SignUpPage() {
  return <Navigate to="/sign-in" replace />
}
